import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import pencilIcon from "@iconify/icons-mdi/pencil";
import { InlineIcon } from "@iconify/react";
import {
  useMyHrChangeRequestsExaminersName,
  useMyHrUserRolesDataByContract,
} from "my-hr/hooks";
import { OcCustomTooltip } from "oc/components";
import { useOcCurrentUserState } from "oc/hooks";

interface OcInfoCardLabelProps {
  label: string;
  editable: boolean;
  type: string;
  onEdit?: (type: string) => void;
  editButtonDisabled: boolean;
}

export const OcInfoCardLabel: React.FC<OcInfoCardLabelProps> = ({
  label,
  editable,
  type,
  onEdit = () => { },
  editButtonDisabled,
}) => {
  const theme = useTheme();
  const handleEditButton = () => {
    if (editButtonDisabled) return null;
    onEdit(type);
  };

  const { t, i18n } = useTranslation();

  let { contractCode } = useOcCurrentUserState();

  const { data: examinersData } = useMyHrChangeRequestsExaminersName({
    locale: i18n.language,
    contract: contractCode,
  });

  const { data: rolesData } = useMyHrUserRolesDataByContract({
    contract: contractCode,
  });

  const isExaminer = rolesData?.find(
    (item: { product: string; role: string }) =>
      item.product === "MyHR" && item.role === "examiner",
  )
    ? true
    : false;

  const hasExaminer = examinersData?.length > 0;

  let isDisabled = !hasExaminer;
  if (isExaminer && !hasExaminer) {
    isDisabled = false;
  }

  if (isDisabled) {
    editable = false;
  }

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box>{label}</Box>
      {editable && (
        <Box
          style={
            editButtonDisabled ? { cursor: "auto" } : { cursor: "pointer" }
          }
          onClick={handleEditButton}
        >
          <InlineIcon
            id={`pencilIcon-oc-card-label${label}`}
            width="18px"
            height="18px"
            icon={pencilIcon}
            color={
              editButtonDisabled
                ? theme.palette.gray40.main
                : theme.palette.gray80.main
            }
          />
        </Box>
      )}
      {isDisabled && (
        <OcCustomTooltip title={t("OC_NOT_SET_EXAMINER_INFO")} placement="top">
          <Box>
            <InlineIcon
              id={`pencilIcon-oc-card-label${label}`}
              width="18px"
              height="18px"
              icon={pencilIcon}
              color={theme.palette.gray40.main}
            />
          </Box>
        </OcCustomTooltip>
      )}
    </Box>
  );
};

export default OcInfoCardLabel;
